import { useState } from 'react';
import { useRoute } from '../../context/RouteContext';
import { useAuth } from '../../context/AuthContext';
import { RouteDetailModal } from '../Community/RouteDetailModal';
import './CommunityRouteInfo.css';

export function CommunityRouteInfo() {
  const { state, dispatch, showToast } = useRoute();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  const meta    = state.current.communityMeta;
  const current = state.current;
  if (!meta) return null;

  // Reconstruct a route object that RouteDetailModal expects
  const route = {
    id:            meta.id ?? current.id?.replace('community_', '') ?? '',
    userId:        meta.userId ?? null,
    name:          meta.name,
    description:   meta.description || '',
    imageUrls:     meta.imageUrls ?? [],
    videoUrls:     meta.videoUrls ?? [],
    userName:      meta.userName,
    userPhoto:     meta.userPhoto ?? null,
    averageRating: meta.averageRating ?? null,
    ratingCount:   meta.ratingCount ?? 0,
    waypoints:     current.waypoints ?? [],
    geometry:      current.geometry ?? null,
    distance:      current.distance ?? null,
    duration:      current.duration ?? null,
    startName:     current.waypoints?.[0]?.name ?? '',
    endName:       current.waypoints?.[current.waypoints.length - 1]?.name ?? '',
    isLoop:        current.waypoints?.some(w => w.isLoopEnd) ?? false,
  };

  function handleUnpublished(routeId) {
    dispatch({ type: 'CLEAR_PUBLISHED', payload: routeId });
    showToast('Route unpublished', 'info');
    setOpen(false);
  }

  return (
    <>
      <button
        className="cri-pill"
        style={{ top: user ? undefined : '116px' }}
        onClick={() => setOpen(true)}
        title="View route details"
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/>
        </svg>
        <span className="cri-pill__label">{meta.name}</span>
        {meta.averageRating != null && meta.ratingCount > 0 && (
          <span className="cri-pill__rating">★ {meta.averageRating.toFixed(1)}</span>
        )}
      </button>

      {open && (
        <RouteDetailModal
          route={route}
          onClose={() => setOpen(false)}
          onUnpublished={handleUnpublished}
        />
      )}
    </>
  );
}
